<!--/* 
 * 备注：因为这是一个全局插件   但是应为需求需要临时存储数据，在不能使用vuex的情况下选择使用locastorage，但是基于locastorage有控件大小的环境下，每一次在使用此插件的父级组件
 * 关闭是请清除locastorage中的sealData数据。
 * 改动————由全局插件改为独立组件，在需要使用的地方进行引用，同时需要在父级组件调用本组件的init方法
 * 2018.11.21 改动————由独立组件改为全局插件（同时也兼容子组件调用），在需要使用的地方调用 this.$pdfFile.install(a, b) a参数为文件Id、b参数为123（分别是签署意见、签名、盖章）
 * 2018.11.26 改动————把签署意见是的背景修改为透明
 * 2018.12.27 新增————文件展示 suffix代表传入文件类型 多传入文件后缀的对象（suffixData:{fileType: '文件后缀'，imgSrc：'图片的路径'}） 这个参数针对图片文件 非图片文件可以不传 毕竟传进来也没什么卵用
 * 2018.12.26 新增————打印 全文件打印功能
 * 2019.1.2   修改————在需要使用的地方调用 this.$pdfFile.install(a, b) a参数改为传入文件的对象(包括{fileId:'文件Id',displayUrl:'displayUrl')、b参数为1234（分别是签署意见、签名、盖章、查看）
 * 2019.1.15  修改————对图片展示做轮播处理
 * 2019.3.15  修改————点击拖动——>按住拖动  单意见签署——>多意见签署
 * 2020.11.2  修改————PDF修改为全文件打印  新增————多图片选择打印
 */-->
<template>
  <div>
    <div class="loadingClass" v-show="percentageType">
      <div class="loadingClassCentre">
        <el-progress type="circle" :percentage="percentage"></el-progress>
      </div>
    </div>
    <!-- <div class='pdf-page'> -->
    <!-- <canvas id="the-canvas"></canvas> -->
    <!-- <div style="width:100px;height:100px ;position: relative;  z-index: 9999;
    background: red;" id="move11" ondragstart='return false;'>   
        <img src="../../../../../../assets/img/dianhua.png" @mousedown="move1" onselectstart="return false;" unselectable="on" style="-moz-user-select:none;width:100%" alt="">
    </div> -->
    <div id="container" v-if="show">
        <div id="the-canvas" @scroll="scrollPdf($event)">
          <div class="pdfClass" :class="{pdfClass1:pdfBig}" :id="'div-pdf-'+pageNum" :style="{width: pdfStyle.width+'px',height: pdfStyle.height+'px','transform':'rotate('+rotatePDF+'deg)','-ms-transform':'rotate('+rotatePDF+'deg)','-moz-transform':'rotate('+rotatePDF+'deg)','-webkit-transform':'rotate('+rotatePDF+'deg)','-o-transform':'rotate('+rotatePDF+'deg)'}">
            <div id="seal_pic_div" v-show="sealState == pageNum && opertation.seal" class="sealPicDiv" :style="{top:sealPicDivList.top*actualScale+sealMove.scrollHeight+'px',left:sealPicDivList.left*actualScale+'px',width:sealPicDivList.width+'px',height:sealPicDivList.height+'px',transform:'scale('+actualScale+')'}">
              <img :src="imgUrl" id="imgId" alt="">
            </div>
            <!--图片显示-->
            <div v-if="suffix == 'img'" class="img_list">
              <div class="suffix_img" @mousedown="move1($event)" :style="{'transform':'translateX(-50%)translateY(-50%)rotate('+rotate+'deg)','-ms-transform':'translateX(-50%)translateY(-50%)rotate('+rotate+'deg)','-moz-transform':'translateX(-50%)translateY(-50%)rotate('+rotate+'deg)','-webkit-transform':'translateX(-50%)translateY(-50%)rotate('+rotate+'deg)','-o-transform':'translateX(-50%)translateY(-50%)rotate('+rotate+'deg)'}">
                <img :src="imgSrc" id="suffixImg" ondragstart='return false;'/>
              </div>
              <div class="img_list_footer">
                <div class="img_list_footer_div" @click="buttonElectImg(-1)"><i class="iconfont iconzuo"></i></div>
                <div class="img_list_footer_ul">

                <ul :style="{'width': constObj.imgListWidth + 'px', 'marginLeft': constObj.marginLeft + 'px'}">
                  <el-checkbox-group v-model="printCheckList">
                    <li v-for="(item,key) of lookImgList" @click="electImg(item.displayUrl,key)" :class="{'img_list_footer_border':key == imgIndexSrc}">
                      <el-checkbox :label="item.displayUrl" v-show="bulkPrintState">{{printCheakBox}}</el-checkbox>
                      <img :src="item.displayUrl" />
                    </li>
                  </el-checkbox-group>
                </ul>
                </div>
                <div class="img_list_footer_div" @click="buttonElectImg(1)"><i class="iconfont iconicon-arrow-right2"></i></div>
              </div>
            </div>
            <div v-else id="showPDF" :class="{cursor_move:sealMove.isDown}"></div>
    <!-- <div class="cover_class" :class="{cursor_move:sealMove.isDown}" v-show="sealState == pageNum" :style="{width: pdfStyle.width+'px',height: pdfStyle.height+'px'}"
              title="单击拖动位置" @mousedown="move($event)" @click="moveup()"> -->
            <div class="cover_class" :class="{cursor_move:sealMove.isDown}" :style="{width: pdfStyle.width+'px',height: pdfStyle.height+'px'}">
              <!-- <div id="seal_pic_div1" @mousedown="move($event)" class="sealPicDiv" v-show="!sealMove.isDown && opertation.seal" :style="{top:sealPicDivList.top*actualScale+sealMove.scrollHeight+'px',left:sealPicDivList.left*actualScale+'px',width:sealPicDivList.width+'px',height:sealPicDivList.height+'px'}"> -->
              <div id="seal_pic_div1" @mousedown="move($event)" class="sealPicDiv" v-show="opertation.seal" :style="{top:sealPicDivList.top*actualScale+sealMove.scrollHeight+'px',left:sealPicDivList.left*actualScale+'px',width:sealPicDivList.width+'px',height:sealPicDivList.height+'px',transform:'scale('+actualScale+')'}">
              </div>
              <div v-for="(item,index) in signerReturnList" v-show="item.pageIndex == pageNum && opertation.signer" class="signer_return_class" style="transform-origin: 0 0" :style="{top:item.top*actualScale+sealMove.scrollHeight+'px',left:item.left*actualScale+'px',transform:'scale('+actualScale+')'}">
                <div class="signer_return_class_drag">
                  <span title="删除当前意见" @click="deleteSigner(index,1)">
                    <i class="iconfont iconclose"></i>
                  </span>
                </div>
                <!-- {{item.top}}{{item.left}} -->
                <img :src="item.imgCode" alt="" style="-moz-user-select:none;">
              </div>
              
              <div v-for="(item,index) in signerList" v-show="item.pageIndex == pageNum && opertation.signer" class="signer_class" :id="'signer_class_drag'+index" style="transform-origin: 0 0" :style="{top:item.top*actualScale+sealMove.scrollHeight+'px',left:item.left*actualScale+'px',transform:'scale('+actualScale+')'}" ondragstart='return false;'>
                <div class="signer_class_drag" @mousedown="move($event,index)">
                  <span title="单击拖动位置">
                    <i class="iconfont iconpdf_icon_move"></i>
                  </span>
                  <span title="删除当前意见" @click="deleteSigner(index,2)">
                    <i class="iconfont iconclose"></i>
                  </span>
                </div>
                <!-- {{item.top}}{{item.left}} -->
                <div :id="'signer_class'+index">
                  <!-- <textarea name="意见" maxlength="225" v-model="item.text" id="my-node" @click.stop="textareaFocus" class="textarea_class" style="width:150px;height:100px;transform-origin: 0 0"
                      placeholder="请输入意见"></textarea> -->
                      <div encreq="false" contenteditable="true" name="意见" placeholder="请输入意见" maxlength="225" v-model="item.text" id="my-node" @click.stop="textareaFocus" class="textarea_class" style="min-width:150px;min-height:100px;white-space: pre;transform-origin: 0 0;text-align: left;max-width:300px;word-break: break-word; word-wrap: break-word;word-wrap:break-word;word-break:break-all;"></div>
                </div>
              </div>
              
            </div>

          </div>
        </div>
        <!--菜单栏-->
        <div class="pdf_titleBar">

          <!--文件名称-->
          <div class="file_name floatLeft">
            {{fileName | substring18}}
          </div>
          <!-- 确定 -->
          <el-button class="button floatRight" type="primary" v-if="opertation.seal || opertation.signer" @click="proceedSeal">确定</el-button>

          <!-- 取消 -->
          <el-button class="button floatRight" @click="close">
            <span v-if="opertation.seal || opertation.signer">取消</span>
            <span v-else>关闭</span>
          </el-button>
          
          <!-- 签署意见 -->
          <div class="zoomInOut floatRight" v-if="opertation.operate == 1 && (signerReturnList.length + signerList.length) <= 49" @click="sealPivState($event)">
            <i class="iconfont iconpdf_icon_font"></i>
            <p>签署意见</p>
          </div>

          <!-- 个人签章 -->
          <div class="zoomInOut floatRight" v-else-if="opertation.operate == 2 " @click="sealPivState($event)">
            <i class="iconfont iconpdf_icon_PersonalSea"></i>
            <p>个人签章</p>
          </div>

          <!-- 企业签章 -->
          <div class="zoomInOut floatRight" v-else-if="opertation.operate == 3 " @click="sealPivState($event)">
            <i class="iconfont iconpdf_icon_CompanySeal"></i>
            <p>企业签章</p>
          </div>

          <!-- 多图打印 -->
          <div class="zoomInOut floatRight" @click="bulkPrint()" v-if="!bulkPrintState && suffix == 'img'">
            <i class="iconfont iconpiliangdayin"></i>
            <p>多图打印</p>

          </div>

          <!-- 关闭多图打印 -->
          <div class="zoomInOut floatRight" @click="endBulkPrint()" v-if="bulkPrintState">
            <i class="iconfont iconpiliangdayintuichu"></i>
            <p>关闭多图打印</p>
          </div>

          <!-- 打印 -->
          <div class="zoomInOut floatRight" @click="print()">
            <i class="iconfont iconpdf_icon_print"></i>
            <p>打印</p>

          </div>

          <!-- 适应页面 -->
          <div class="zoomInOut floatRight" @click="scaleStartSize($event)" v-if="!bulkPrintState">
            <i class="iconfont iconpdf_icon_zoom_fit"></i>
            <p>适应页面</p>
          </div>

          <!--旋转-->
          <!-- <div v-if="suffix == 'img' && !bulkPrintState" class="zoomInOut floatRight" @click="rotateClick('suffixImg','right')"> -->
          <div v-if="!bulkPrintState" class="zoomInOut floatRight" @click="rotateClick('suffixImg','right')">
            <i class="icon_size el-icon-refresh"></i>
            <p>旋转</p>
          </div>

          <!--放大-->
          <div class="zoomInOut floatRight" @click="scaleSize('big')" v-if="!bulkPrintState">
            <i class="iconfont iconpdf_icon_zoom"></i>
            <p>放大</p>
          </div>

          <!--缩小-->
          <div class="zoomInOut floatRight" @click="scaleSize('small')" v-if="!bulkPrintState">
            <i class="iconfont iconpdf_icon_zoom-"></i>
            <p>缩小</p>
          </div>

          <!--页码-->
          <div class="floatCenter" v-if="suffix != 'img'">
            <!--上一页-->
            <div class="zoomInOut display" @click="onPrevPage">
              <i class="iconfont iconpdf_icon_PgUp"></i>
              <p>上一页</p>
            </div>
            <!--第一页-->
            <div class="zoomInOut page_num display">
              <input type="text" class="page_inp" v-model="pageNum" @keyup="jump" />
              <span class="color"> / {{pdfLength}}</span>
            </div>
            <!--下一页-->
            <div class="zoomInOut display" @click="onNextPage">
              <i class="iconfont iconpdf_icon_PgDn"></i>
              <p>下一页</p>
            </div>
          </div>

        </div>
        <!-- </div> -->
        <div id="prantId" style="display:none"></div>
        <div id="prantPdf" style="display:none"></div>
    

    </div>
    
  </div>
</template>
<script>
  import PDFJS from "pdfjs-dist-di";
  // import PDFJS from '../../../../../config/pdf.js'
  // import domtoimage from 'dom-to-image'
  import html2canvas from "html2canvas";
  // import PDFJS from '../../static/pdf.js'
  //创建和pdf页数等同的canvas数
  function createSeriesCanvas(num, template) {
    var id = "";
    for (var j = 1; j <= num; j++) {
      id = template + j;
      createPdfContainer(id, "pdfClass1", template);
    }
  }
  //创建
  function createPdfContainer(id, className, divId) {
    if (divId == "prantId") {
      var pdfContainer = document.getElementById("prantId");
    } else {
      var pdfContainer = document.getElementById("showPDF");
    }
    var canvasNew = document.createElement("canvas");
    canvasNew.id = id;
    canvasNew.className = 'printClass'
    pdfContainer.appendChild(canvasNew);
  }
  export default {
    data() {
      return {
        printCheakBox: '',
        printCheckList: [], // 多张图片打印选中图片
        rotate: 0, // 旋转角度
        rotatePDF: 0, // 旋转角度
        operationState: false, // 同一文件是否已经进行过操作
        pdfDoc: null, // pdf 原型对象
        pageNum: 1, // pdf当前显示页码
        pageRendering: false,
        pageNumPending: null,
        scale: 1.0, // pdf缩放比例
        actualScale: 1.0, // pdf缩放比例
        // 其他数据
        show: false, // 显示PDF
        pdfLength: 0, // pdf总页数
        pdfStyle: {
          // 单页PDF的大小
          width: "",
          height: ""
        },
        pdfBig: false, // pdf单页实际高度是否比显示高度大
        sealPicDivList: {
          // 印章签名的大小及位置控制
          top: "",
          left: "",
          width: "",
          height: "",
          initialWidth: 120, // 初始印章宽度
          initialHeight: 120 // 初始印章高度
          // initialWidth: 0, // 初始印章宽度
          // initialHeight: 0 // 初始印章高度
        },
        sealMove: {
          // 印章拖拽定点位置
          startx: "", // clientX
          starty: "", // clientY
          startLeft: "", // left
          startTop: "", // top
          endTop: "",
          endLeft: "",
          isDown: false, // 是否定点操作
          getX: 0, // 坐标点（数据传输用）
          getY: 0, // 坐标点（数据传输用）
          scrollHeight: 0, // 滚动高度
          scrollTop: 0,
          scrollHeight1: 0, // 滚动高度预处理1
          scrollHeight2: 0 // 滚动高度预处理2
        },
        sealState: "", // 章印的页数
        signState: true,
        signState1: true,
        opertation: {
          // 操作
          seal: false, // 盖章操作
          signer: false, // 签署意见操作
          operate: 0 // 具体操作 1：个人意见，2：个人签章，3：企业意见
        },
        imgUrl: "",
        imgState: false,
        sealData: {
          fileId: 0
        }, // 数据
        updateData: {
          state: false, // 是否修改  默认false不是修改
          id: "" // 修改的ID
        }, // 修改时的数据
        twice: false, // 是否是翻页
        imgSrc: "../../../../../../assets/img/shortTime.png",
        suffix: "",
        lookImgList: [], // 查看图片的集合
        imgIndexSrc: 0, // 当前展示图片文件在所在图片集合中的序号
        positionX:'',
        positionY:'',
        signerReturnList: [], // 多意见数据集合
        signerList: [], // 多意见数据集合
        signerId: 0, // 多意见生成临时ID
        canvasSize: {
          width: '',
          height: ''
        }, // 画布大小
        percentage: 0,
        percentageType: false,
        fileName: null,
        constObj: {
          imgListWidth: 0,
          marginLeft: 0,
          imgListLength: 0, // imgList总长度 
          imgListIndex: 0,  // img当前展示的index
        },
        bulkPrintState: false // 多文件打印
      };
    },
    props: ["pdfId"],
    mounted() {
      // this.init()
      
    },
    methods: {
      rotateClick(o,p){ 
        if(this.suffix == 'img'){
          this.rotate = this.rotate + 90
        }else {
          this.rotatePDF = this.rotatePDF + 90
        }
        // var img = document.getElementById(o); 
        // if(!img || !p) return false; 
        // var n = img.getAttribute('step'); 
        // if(n== null) n=0; 
        // if(p=='right'){ 
        //     (n==3)? n=0:n++; 
        // }else if(p=='left'){ 
        //     (n==0)? n=3:n--; 
        // } 
        // img.setAttribute('step',n); 
        // //MSIE 
        // if(document.all) { 
        //     img.style.filter = 'progid:DXImageTransform.Microsoft.BasicImage(rotation='+ n +')'; 
        //     //HACK FOR MSIE 8 
        //     switch(n){ 
        //         case 0: 
        //             img.parentNode.style.height = img.height; 
        //             break; 
        //         case 1: 
        //             img.parentNode.style.height = img.width; 
        //             break; 
        //         case 2: 
        //             img.parentNode.style.height = img.height; 
        //             break; 
        //         case 3: 
        //             img.parentNode.style.height = img.width; 
        //             break; 
        //     } 
        // //DOM 
        // }else{ 
        //     var c = document.getElementById('canvas_'+o); 
        //     if(c== null){ 
        //         img.style.visibility = 'hidden'; 
        //         img.style.position = 'absolute'; 
        //         c = document.createElement('canvas'); 
        //         c.setAttribute("id",'canvas_'+o); 
        //         img.parentNode.appendChild(c); 
        //     } 
        //     var canvasContext = c.getContext('2d'); 
        //     let odiv = document.getElementById('suffixImg')
        //     let odiv1 = document.getElementsByClassName('suffix_img')
        //     switch(n) { 
        //         default : 
        //         case 0 : 
        //             c.setAttribute('width', odiv1[0].clientHeight*odiv.clientWidth/odiv.clientHeight); 
        //             c.setAttribute('height', odiv1[0].clientHeight); 
        //             canvasContext.rotate(0 * Math.PI / 180); 
        //             canvasContext.drawImage(img, 0, 0); 
        //             break; 
        //         case 1 : 
        //             c.setAttribute('width', odiv1[0].clientHeight*odiv.clientWidth/odiv.clientHeight); 
        //             c.setAttribute('height', odiv1[0].clientHeight); 
        //             canvasContext.rotate(90 * Math.PI / 180); 
        //             canvasContext.drawImage(img, 0, -img.height); 
        //             break; 
        //         case 2 : 
        //             c.setAttribute('width', odiv1[0].clientHeight*odiv.clientWidth/odiv.clientHeight); 
        //             c.setAttribute('height', odiv1[0].clientHeight); 
        //             canvasContext.rotate(180 * Math.PI / 180); 
        //             canvasContext.drawImage(img, -img.width, -img.height); 
        //             break; 
        //         case 3 : 
        //             c.setAttribute('width', odiv1[0].clientHeight*odiv.clientWidth/odiv.clientHeight); 
        //             c.setAttribute('height', odiv1[0].clientHeight); 
        //             canvasContext.rotate(270 * Math.PI / 180); 
        //             canvasContext.drawImage(img, -img.width, 0); 
        //             break; 
        //     } 
        // } 
    } ,
      _loading() {
        loadingInstance = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-iconloading",
          background: "rgba(0, 0, 0, 0.2)"
        });
      },
      // 进度百分比
      percentageCount(){
        let _a = setTimeout(val => {
          this.percentage += 1
          if(this.percentage < 30 && this.percentageType){
            this.percentageCount()
          }else if(this.percentageType){
            this.percentageCount1()
          }
        },200)
      },
      percentageCount1(){
        let _a = setTimeout(val => {
          this.percentage += 1
          if(this.percentage < 60 && this.percentageType){
            this.percentageCount1()
          }else if(this.percentageType){
            this.percentageCount2()
          }
        },400)
      },
      percentageCount2(){
        let _a = setTimeout(val => {
          this.percentage += 1
          if(this.percentage < 90 && this.percentageType){
            this.percentageCount2()
          }else if(this.percentageType){
            this.percentageCount3()
          }
        },800)
      },
      percentageCount3(){
        let _a = setTimeout(val => {
          this.percentage += 1
          if(this.percentage < 96 && this.percentageType){
            this.percentageCount3()
          }
        },2000)
      },
      // 计算选中展示位置
      imgPitchon(imgListLength,imgindex){
        this.constObj.imgListIndex = imgindex
        this.constObj.imgListLength = imgListLength
        if(imgListLength<=14 || imgListLength>14 && imgindex<=7)
          return
        if(imgListLength>14 && imgindex > 7){
          this.constObj.marginLeft = -(imgindex-7) * 68
        }
      },
      // 插件初始方法
      init(fileID, operate, suffixData) {
        // 打开文件
        this.rotatePDF = 0
        this.rotate = 0
        this.signerList = []
        this.signerReturnList = []
        if (typeof suffixData != "undefined" && suffixData.fileType == "img") {
          this.suffix = suffixData.fileType;
          this.imgSrc = suffixData.imgList[suffixData.imgIndex].displayUrl;
          suffixData.imgList[suffixData.imgIndex].fileName?this.fileName = suffixData.imgList[suffixData.imgIndex].fileName : null;
          this.imgIndexSrc = suffixData.imgIndex
          this.lookImgList = suffixData.imgList;
          this.constObj.imgListWidth = suffixData.imgList.length * 68
          // 因为存在多张图片 所以需要计算打开时展示定位位置
          this.imgPitchon(suffixData.imgList.length,suffixData.imgIndex)
          this.opertation.operate = operate;
          this.show = true;
        } else {
          // this._loading();
          if(loadingInstance!=null){
            loadingInstance.close()
          }
          this.percentageType = true
          this.percentageCount()

          let params = new URLSearchParams();
          params.append("token", this.$user.get_data("userData").token);
          params.append("fileId", fileID);
          // typeof suffixData != "undefined" ?
          //   params.append("fileType", suffixData.fileMold) :
          //   "";
          if(typeof suffixData != "undefined" && suffixData.fileMold){
            params.append("fileType", suffixData.fileMold)
          }
          if(typeof suffixData != "undefined" && suffixData.displayUrl){
            params.append("displayUrl", suffixData.displayUrl)
          }
          let that = this;
          this.axios({
              method: "POST",
              url: "/project/showFile",
              responseType: "arraybuffer",
              headers: {
                'Content-Length': 348,
                "Content-Encoding": "UTF-8"
			        },
              data: params,
              onUploadProgress:function(progressEvent){ //原生获取上传进度的事件
                if(progressEvent.lengthComputable){
                    //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
                    //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
                    // callback1(progressEvent);
                    let loaded = progressEvent.loaded,
                    total = progressEvent.total;
                    that.$nextTick(() =>{
                      // _this.precent = (loaded/total) * 100;
                      // console.log((loaded/total) * 100*0.2)
                    })
                }
            },
              onDownloadProgress:function(progressEvent){ //原生获取下载进度的事件
                if(progressEvent.lengthComputable){
                    //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
                    //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
                    // callback1(progressEvent);
                    let loaded = progressEvent.loaded,
                    total = progressEvent.total;
                    that.$nextTick(() =>{
                      // that.percentage = parseInt((loaded/total) * 98)
                      if(parseInt((loaded/total) * 98)>=98){

                      }
                      
                    })
                }
              },
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            })
            .then(response => {
              //创建blob对象
              // if(response.data.code != 1)
              //   return this.$message.error(response.data.errorMessage)
              let blob = new Blob([response.data]);
              this.showPDF(URL.createObjectURL(blob), operate, fileID);
              suffixData&&suffixData.fileName?this.fileName = suffixData.fileName : null
            })
            .catch(reject => {
              loadingInstance.close();
              this.close()
              this.$message.error("系统错误");
            });
        }
      },

      // 插件调用方法 operate 1=签署意见 2=签名 3=签章
      showPDF(url, operate, fileID) {
        Object.assign(this.$data, this.$options.data());

        let _this = this;
        _this.show = true;
        this.sealData.fileId = fileID;
        // PDFJS.workerSrc = '../../static/pdf.worker.js'
        //   let _url = encodeURIComponent(url) // 转化汉字
        // PDFJS.getDocument(url)
        PDFJS.getDocument({
          url: url,
          cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.943/cmaps/',
          cMapPacked: true
        })
          .then(function (pdf) {
            _this.pdfDoc = pdf;
            var id = "";
            var idTemplate = "cw-pdf-";
            var pageNum = pdf.numPages;
            _this.pdfLength = pdf.numPages;
            //根据页码创建画布
            createSeriesCanvas(1, idTemplate);

            //将pdf渲染到画布上去
            _this.renderPage(pdf, 1, idTemplate + "1");
            // loadingInstance.close();
            _this.dataDispose(operate);
            _this.percentageType = false
          })
          .catch(reject => {
            _this.show = false;
            // loadingInstance.close();
            _this.close()
            return this.$message.error("PDF文件加载失败，请重试！！！");
          });
      },
      // 获取章印图片方法
      getSealImg(operate) {
        let _url = "";
        let userData = this.$user.get_data("userData");
        let params = new URLSearchParams();
        params.append("token", userData.token);
        if (operate == 2) {
          // _url = "/api/sign/image"; // 个人章
          this.$axios(
            this.$axiosConst.signImage,
            params
          )
          .then(res => {
            // loadingInstance.close();
            this.percentageType = false
            if (res.data.code != 1) {
              return this.$message.error(res.data.errorMessage);
            }
            setTimeout(val => {
              if (operate == 2) {
                this.imgUrl = "data:image/png;base64," + res.data.data;
              } else {
                this.imgUrl = "data:image/png;base64," + res.data.data[0].img;
              }
            }, 100);

            // this.sealPicDivList.width = document.getElementById('imgId').style.width
          })
          .catch(reject => {
            this.close()
            // loadingInstance.close();
            this.close()
            this.$message.error("系统错误");
          });
        } else {
          // _url = "api/enter/sign/library";
           this.$axios(
            this.$axiosConst.signLibrary,
            params
          )
          .then(res => {
            // loadingInstance.close();
            this.percentageType = false
            if (res.data.code != 1) {
              return this.$message.error(res.data.errorMessage);
            }
            setTimeout(val => {
              if (operate == 2) {
                this.imgUrl = "data:image/png;base64," + res.data.data;
              } else {
                this.imgUrl = "data:image/png;base64," + res.data.data[0].img;
              }
            }, 100);

            // this.sealPicDivList.width = document.getElementById('imgId').style.width
          })
          .catch(reject => {
            this.close()
            // loadingInstance.close();
            this.close()
            this.$message.error("系统错误");
          });
        }
        // this.axios({
        //     method: "POST",
        //     url: _url,
        //     data: params
        //   })
          // .then(res => {
          //   // loadingInstance.close();
          //   this.percentageType = false
          //   if (res.data.code != 1) {
          //     return this.$message.error(res.data.errorMessage);
          //   }
          //   setTimeout(val => {
          //     if (operate == 2) {
          //       this.imgUrl = "data:image/png;base64," + res.data.data;
          //     } else {
          //       this.imgUrl = "data:image/png;base64," + res.data.data[0].img;
          //     }
          //   }, 100);

          //   // this.sealPicDivList.width = document.getElementById('imgId').style.width
          // })
          // .catch(reject => {
          //   this.close()
          //   // loadingInstance.close();
          //   this.close()
          //   this.$message.error("系统错误");
          // });
      },
      // 数据的二次反现
      dataDispose(operate) {
        this.percentageType = false
        let _sealDataList = this.$store.state.sealData.sealList;
        let _sealData;
        let _sealFrimData;
        // for(let i of _sealDataList){

        //   if(i.id == id){
        //     localStorage.setItem('sealData',i)
        //   }
        // }
        if (operate == 1) {
          this.opertation.signer = true;
          if (_sealDataList.length != 0) {
            _sealData = _sealDataList[0];
          }
          // loadingInstance.close();
          this.percentageType = false
          this.percentage = 0
        } else if (operate == 2) {
          this.opertation.seal = true;
          if (_sealDataList.length != 0) {
            _sealData = _sealDataList[0];
          }
          // 获取章印图片
          this.getSealImg(operate);
        } else if (operate == 3) {
          this.opertation.seal = true;
          if (_sealDataList.length != 0) {
            _sealFrimData = _sealDataList[0];
          } else {
            // 获取章印图片
            this.getSealImg(operate);
          }
        } else {}
        this.opertation.operate = operate;
        if (_sealData) {
          setTimeout(val => {
            this.operationState = _sealData.operationState;
            _sealData.sealPicDivList.top = _sealData.sealPicDivList.top + 24
            this.sealPicDivList = _sealData.sealPicDivList;
            this.sealMove = _sealData.sealMove;
            // this.imgUrl = _sealData.imgCode;
            this.imgState = true;
            this.signState = false;
            this.signState1 = false;
            this.sealState = _sealData.sealState;
            this.signerReturnList = _sealDataList;
            // loadingInstance.close();
            this.percentage = 0
            this.percentageType = false
          }, 200);
        }
        if (_sealFrimData) {
          setTimeout(val => {
            this.updateData.state = true;
            this.updateData.id = _sealFrimData.id;
            this.operationState = true;
            this.sealState = _sealFrimData.pageNum;
            this.imgUrl = "data:image/png;base64," + _sealFrimData.img;
            this.imgState = true;
            this.signState = false;
            this.signState1 = false;
            this.sealMove.endTop = 1;
            this.sealPicDivList.top = _sealFrimData.yPoint * this.actualScale;
            this.sealPicDivList.left = _sealFrimData.xPoint * this.actualScale;
            this.sealPicDivList.width =
              _sealFrimData.stampWidth * this.actualScale;
            this.sealPicDivList.height =
              _sealFrimData.stampHeight * this.actualScale;
            // loadingInstance.close();
            this.percentage = 0
            this.percentageType = false
          }, 200);
        }
        // localStorage.removeItem('sealData')
      },
      // 处理印章大小
      sealPicDivFun(width, height) {
        this.sealPicDivList.top = 0 - height / 2;
        this.sealPicDivList.left = 0 - width / 2;
        // 按比例控制印章大小的展示
        this.sealPicDivList.width = width * this.actualScale;
        this.sealPicDivList.initialWidth = width * this.actualScale;
        this.sealPicDivList.height = height * this.actualScale;
        this.sealPicDivList.initialHeight = height * this.actualScale;
      },
      // 渲染PDF
      renderPage(pdf, i, id, type) {
        this.pageRendering = true;
        let _this = this;
        this.pdfDoc.getPage(i).then(function (page) {
          if (!type) {
            _this.actualScale =
              ((document.body.clientHeight - 70) /
                page.getViewport(1.0 - (_this.scale - 1.0)).height);
          } else {
            _this.actualScale = 1.0;
          }
          var viewport = page.getViewport(_this.actualScale);
          // 调用处理印章签名的大小方法
          if (!_this.twice) {
            _this.twice = true;
            if (_this.opertation.operate == 2) {
              _this.sealPicDivFun(120, 120 / 2);
            } else if (_this.opertation.operate == 3) {
              _this.sealPicDivFun(120, 120);
            }
          }

          // _this.shify() // 暂时停用   后面补上
          let canvas = document.getElementById(id);
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          _this.canvasSize.width = viewport.width
          _this.canvasSize.height = viewport.height
          _this.pdfStyle.width = viewport.width;
          _this.pdfStyle.height = viewport.height;
          // Render PDF page into canvas context
          var renderContext = {
            canvasContext: canvas.getContext("2d"),
            viewport: viewport
          };
          var renderTask = page.render(renderContext);
          if (
            viewport.height <
            document.getElementById("the-canvas").offsetHeight - 56
          ) {
            _this.pdfBig = true;
          } else {
            _this.pdfBig = false;
          }

          // Wait for rendering to finish
          renderTask.promise.then(function () {
            _this.pageRendering = false;
            if (_this.pageNumPending !== null) {
              // New page rendering is pending
              this.renderPage(_this.pageNumPending);
              _this.pageNumPending = null;
            }
          });
        });
      },
      // 渲染PDF
      renderPage1(pdf, i, id) {
        createSeriesCanvas(this.pdfLength, "prantId");
        // createSeriesCanvas(1, "prantId");
        setTimeout(val => {
          let _this = this;
          for (var j = 1; j <= this.pdfLength; j++) {
            (function(j) {
              _this.pdfDoc.getPage(j).then(function (page) {
                var viewport = page.getViewport(1.0 * 1.8);
                // _this.shify() // 暂时停用   后面补上
                let canvas = document.getElementById("prantId"+j);
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                // Render PDF page into canvas context
                var renderContext = {
                  canvasContext: canvas.getContext("2d"),
                  viewport: viewport
                };
                var renderTask = page.render(renderContext);
                // Wait for rendering to finish
                renderTask.promise.then(function () {
                  _this.pageRendering = false;
                  if (_this.pageNumPending !== null) {
                    // New page rendering is pending
                    _this.renderPage1(_this.pageNumPending);
                    _this.pageNumPending = null;
                  }
                });
              });
            })(j);
            
          }
          
        }, 2000);
      },
      // 重置PDF上设定的印章或者签署意见的大小及位置
      shify() {
        this.sealPicDivList.top = this.sealMove.endTop * this.actualScale;
        this.sealPicDivList.left = this.sealMove.endLeft * this.actualScale;
        // this.sealPicDivList.width =
        //   this.sealPicDivList.initialWidth * this.actualScale
        // this.sealPicDivList.height =
        //   this.sealPicDivList.initialHeight * this.actualScale
      },
      queueRenderPage(num) {
        if (this.pageRendering) {
          this.pageNumPending = num;
        } else {
          this.renderPage(num);
        }
      },
      // 切换页码
      jump() {
        // this.naver('div-pdf-' + this.pageNum)
        let idTemplate = "cw-pdf-";
        this.renderPage("", Number(this.pageNum), idTemplate + 1);
      },
      onPrevPage() {
        if (this.pageNum <= 1) {
          return;
        }
        this.pageNum--;
        let idTemplate = "cw-pdf-";
        this.renderPage("", this.pageNum, idTemplate + 1);
        
        // this.naver('div-pdf-' + this.pageNum)
      },
      onNextPage() {
        if (this.pageNum >= this.pdfDoc.numPages) {
          return;
        }
        this.pageNum++;
        let idTemplate = "cw-pdf-";
        this.renderPage("", this.pageNum, idTemplate + 1);
        // this.naver('div-pdf-' + this.pageNum)
      },
      naver(id) {
        var obj = document.getElementById(id);
        var oPos = obj.offsetTop;
        return document.getElementById("the-canvas").scrollTo(0, oPos);
      },
      close() {
        // 关闭PDF
        this.show = false;
        this.pdfStyle.width = "";
        this.pdfStyle.height = "";
        this.percentage = 0
        this.percentageType = false;
      },
      scaleSize(size) {
        // 缩放功能
        if (this.sealMove.isDown)
          return this.$message.error("你正在进行签名或者盖章");
        let idTemplate = "cw-pdf-";
        if (size == "big") {
          if (this.suffix != "img") {
            if (this.scale > 2) {
              return;
            }
            this.scale = this.scale + 0.2;
            this.renderPage("", this.pageNum, idTemplate + 1);
            // this.sealPicDivList.top = this.sealMove.endTop * this.actualScale
            // this.sealPicDivList.left = this.sealMove.endLeft * this.actualScale
          } else {
            let odiv = document.getElementsByClassName('suffix_img')
            odiv[0].style.height = odiv[0].clientHeight * 1.2 + 'px'
          }
        } else {
          if (this.suffix != "img") {
            if (this.scale < 0.4) {
              return;
            }
            this.scale = this.scale - 0.2;
            this.renderPage("", this.pageNum, idTemplate + 1);
            // this.sealPicDivList.top = this.sealMove.endTop * this.actualScale
            // this.sealPicDivList.left = this.sealMove.endLeft * this.actualScale
          } else {
            let odiv = document.getElementsByClassName('suffix_img')
            odiv[0].style.height = odiv[0].clientHeight * 0.8 + 'px'
          }
        }
        // this.sealPicDivList.width = this.sealPicDivList.initialWidth * this.actualScale
        // this.sealPicDivList.height =
        //   this.sealPicDivList.initialHeight * this.actualScale
        
      },
      // 适应页面
      scaleStartSize() {
        if(this.suffix == 'img'){
          let odiv = document.getElementsByClassName('suffix_img')
          odiv[0].style.height = '100%'
        }else{
          if (this.sealMove.isDown)
            return this.$message.error("你正在进行签名或者盖章");
          let idTemplate = "cw-pdf-";
          this.scale = 1.0;
          // this.sealPicDivList.top = this.sealMove.endTop * this.scale;
          // this.sealPicDivList.left = this.sealMove.endLeft * this.scale;
          // this.sealPicDivList.width = this.sealPicDivList.initialWidth * this.scale;
          // this.sealPicDivList.height =
          //   this.sealPicDivList.initialHeight * this.scale;
          this.renderPage("", this.pageNum, idTemplate + 1);
        }
        
      },
      scrollPdf(ev) {
        this.sealMove.isDown = false;
        let _canvas = document.getElementById("the-canvas");

        if (this.sealMove.isDown) {
          if (this.sealMove.scrollTop <= _canvas.scrollTop) {
            this.sealMove.scrollHeight = _canvas.scrollTop;
          } else {
            this.sealMove.scrollHeight = _canvas.scrollTop;
          }
          this.sealMove.scrollTop = _canvas.scrollTop;
        } else {
          this.sealMove.scrollHeight1 = _canvas.scrollTop;
        }
      },
      idea() {
        // 激活签署意见
        if (
          this.operationState ||
          (!this.operationState && this.sealState != this.pageNum)
        ) {
          this.openChange();
        } else {
          this.sealState = this.pageNum;
        }
      },
      proceedSeal() {
        // var node = document.getElementById('my-node')
        // node.style.width = parseInt(node.style.width) * this.actualScale + 'px'
        // node.style.height = parseInt(node.style.height) * this.actualScale + 'px'
        if (this.$store.state.sealData.sealList.length != 0 && !this.opertation.signer || this.signerReturnList.length != 0 && this.opertation.signer && this.signerList.length == 0) this.close();
        if (!this.sealMove.endTop && this.opertation.operate == 1) {
          return this.$message.error("你还没有进行意见签署");
        } else if (!this.sealMove.endTop && this.opertation.operate == 2) {
          return this.$message.error("你还没有签字");
        } else if (!this.sealMove.endTop && this.opertation.operate == 3) {
          return this.$message.error("你还没有盖章");
        }
        // this.$store.state.sealData.sealList = []
        this.operationState = true;
        
        let _data = {
          proportion: 1.0,
          positionX: this.sealPicDivList.left / this.actualScale,
          positionY: this.sealPicDivList.top / this.actualScale,
          // width: this.sealPicDivList.width,
          // height: this.sealPicDivList.height,
          pageIndex: this.pageNum,
          fileId: this.sealData.fileId,
          imgCode: "",
          sealMove: this.sealMove,
          operationState: this.operationState,
          sealPicDivList: this.sealPicDivList,
          imgState: this.imgState,
          sealState: this.sealState
        };
        this.signState1 = false;
        setTimeout(val => {
          if (this.opertation.operate == 1) {
            // let node = document.getElementById("my-node");
            for(let i = 0; i < this.signerList.length; i++){
              let _data1 = {
                proportion: 1.0,
                positionX: 0,
                positionY: 0,
                // width: this.sealPicDivList.width,
                // height: this.sealPicDivList.height,
                pageIndex: this.signerList[i].pageIndex,
                fileId: this.sealData.fileId,
                imgCode: "",
                sealMove: this.sealMove,
                operationState: this.operationState,
                sealPicDivList: this.sealPicDivList,
                imgState: this.imgState,
                sealState: this.sealState
              };
              let node1 = document.getElementById("signer_class_drag"+i);
              let node2 = document.getElementsByClassName("signer_class_drag");
              let node = document.getElementById("signer_class"+i);
              node1.style.transform = "scale(1)";
              node1.style.display = "block";
              // node.style.zIndex = "2000";
              html2canvas(document.querySelector("#signer_class"+i), {
                  allowTaint: true,
                  backgroundColor: "transparent"
                  // width:parseInt(node.style.width)*2,
                  // height:parseInt(node.style.height)*2,
                })
                .then(canvas => {
                  //  this.imgState = true
                  // this.imgUrl = dataUrl
                  this.imgUrl = canvas.toDataURL("image/png");
                  this.imgState = true;
                  _data1.imgCode = this.imgUrl;
                  _data1.width = node.clientWidth / this.actualScale;
                  _data1.height = node.clientHeight / this.actualScale;
                  _data1.top = (parseInt(node1.style.top))/ this.actualScale+parseInt(node2[0].clientHeight);
                  _data1.left = parseInt(node1.style.left)/ this.actualScale;
                  _data1.positionX = parseInt(node1.style.left)/ this.actualScale;
                  _data1.positionY = (parseInt(node1.style.top))/ this.actualScale+parseInt(node2[0].clientHeight);
                  this.$store.state.sealData.sealList.push(_data1);
                  if(i+1 == this.signerList.length){
                    this.close();
                  }
                })
                .catch(function (error) {
                  console.error("oops, something went wrong!", error);
                });
            }
            
          } else if (this.opertation.operate == 2) {
            _data.width =
              parseInt(document.getElementById("seal_pic_div1").style.width) /
              this.actualScale;
            _data.height =
              parseInt(document.getElementById("seal_pic_div1").style.height) /
              this.actualScale;
            this.$store.state.sealData.sealList.push(_data);
            this.close();
          } else {
            /* 企业章处理 */
            _data.width =
              parseInt(document.getElementById("seal_pic_div1").style.width) /
              this.actualScale;
            _data.height =
              parseInt(document.getElementById("seal_pic_div1").style.height) /
              this.actualScale;
            let userData = this.$user.get_data("userData");
            let _url;
            if (this.updateData.state) {
              // _url = "/api/enter/sign/task/updateOrDelete";
              let params = new URLSearchParams();
            params.append("token", userData.token);
            params.append("fileId", _data.fileId);
            params.append("id", this.updateData.id);
            params.append("xPoint", _data.positionX);
            params.append("yPoint", _data.positionY);
            params.append("pageNum", _data.pageIndex);
            params.append("type", 2);
            params.append("ruleNum", "zjyt_official_seal");
            params.append("stampWidth", _data.width);
            params.append("stampHeight", _data.height);
            params.append("img", this.imgUrl);
              this.$axios(
                this.$axiosConst.taskUpdateOrDelete,
                params
              )
              .then(res => {
                if (res.data.code != 1) {
                  // loadingInstance.close();
                  this.close()
                  return this.$message.error(res.data.errorMessage);
                }
                this.$emit("fireSeal");
                // this.$store.state.sealData.sealList = []
                // loadingInstance.close();
                this.close();
              })
              .catch(reject => {
                // loadingInstance.close();
                this.close()
                this.$message.error("系统错误");
              });
            } else {
              // _url = "/api/enter/sign/task";
              let params = new URLSearchParams();
            params.append("token", userData.token);
            params.append("fileId", _data.fileId);
            params.append("id", this.updateData.id);
            params.append("xPoint", _data.positionX);
            params.append("yPoint", _data.positionY);
            params.append("pageNum", _data.pageIndex);
            params.append("type", 2);
            params.append("ruleNum", "zjyt_official_seal");
            params.append("stampWidth", _data.width);
            params.append("stampHeight", _data.height);
            params.append("img", this.imgUrl);
              this.$axios(
                this.$axiosConst.signTask,
                params
              )
              .then(res => {
                if (res.data.code != 1) {
                  // loadingInstance.close();
                  this.close()
                  return this.$message.error(res.data.errorMessage);
                }
                this.$emit("fireSeal");
                // this.$store.state.sealData.sealList = []
                // loadingInstance.close();
                this.close();
              })
              .catch(reject => {
                // loadingInstance.close();
                this.close()
                this.$message.error("系统错误");
              });
            }
            // let params = new URLSearchParams();
            // params.append("token", userData.token);
            // params.append("fileId", _data.fileId);
            // params.append("id", this.updateData.id);
            // params.append("xPoint", _data.positionX);
            // params.append("yPoint", _data.positionY);
            // params.append("pageNum", _data.pageIndex);
            // params.append("type", 2);
            // params.append("ruleNum", "zjyt_official_seal");
            // params.append("stampWidth", _data.width);
            // params.append("stampHeight", _data.height);
            // params.append("img", this.imgUrl);
            // this.axios({
            //     method: "POST",
            //     url: _url,
            //     data: params
            //   })
              // .then(res => {
              //   if (res.data.code != 1) {
              //     // loadingInstance.close();
              //     this.close()
              //     return this.$message.error(res.data.errorMessage);
              //   }
              //   this.$emit("fireSeal");
              //   // this.$store.state.sealData.sealList = []
              //   // loadingInstance.close();
              //   this.close();
              // })
              // .catch(reject => {
              //   // loadingInstance.close();
              //   this.close()
              //   this.$message.error("系统错误");
              // });
          }
        }, 200);
      },

      sealPivState(ev) {
        // 点击签名进行盖章定点
        if (
          this.operationState&&!this.opertation.signer ||
          (!this.operationState &&
            this.sealState != this.pageNum &&
            this.sealState&&!this.opertation.signer)
        ) {
          this.openChange();
        } else {
          if(this.scale != 1.0){
            this.scale = 1.0;
            this.sealPicDivList.width = this.sealPicDivList.initialWidth;
            this.sealPicDivList.height = this.sealPicDivList.initialHeight;
            let idTemplate = "cw-pdf-";
            this.renderPage("", this.pageNum, idTemplate + 1);
          }
          setTimeout(val => {
            this.sealState = this.pageNum;
            // let oevent = ev || event
            // this.sealMove.isDown = true
            this.sealPicDivList.top = 30;
            // oevent.clientY - this.sealPicDivList.height / 2 - 56
            this.sealPicDivList.left = 30;
                this.sealMove.endTop = top + 24;
                if(this.opertation.signer){
                  this.signerList.push({
                    top: 30+this.signerList/length,
                    left: 30+this.signerList/length,
                    pageIndex: this.pageNum
                  })
                }
                this.signerId = this.signerId + 1
            // oevent.clientX -
            // (document.body.offsetWidth - this.pdfStyle.width) / 2 -
            // this.sealPicDivList.width / 2
            // this.sealMove.startx = oevent.clientX
            // this.sealMove.starty = oevent.clientY
            // this.sealMove.startTop = this.sealPicDivList.top
            // this.sealMove.startLeft = this.sealPicDivList.left
          }, 100);
        }
      },
      textareaFocus() {
        // 签署意见是的焦点获取
        this.signState = true;
        this.sealMove.isDown = false;
      },
      movedown(ev) {
        if (this.operationState) return;
        let oevent = ev || event;
        if (this.scale != 1.0)
          return this.$message.error("请回到适应页面进行拖拽操作");
        if (this.sealMove.isDown) {
          this.sealMove.isDown = false;
        } else {
          this.sealMove.isDown = true;
        }
        this.sealMove.startx = oevent.clientX;
        this.sealMove.starty = oevent.clientY;
        this.sealMove.startTop = this.sealPicDivList.top;
        this.sealMove.startLeft = this.sealPicDivList.left;
      },
      move1(e){
            let odiv = e.currentTarget;        //获取目标元素
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft;
            let disY = e.clientY - odiv.offsetTop;
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX;    
                let top = e.clientY - disY;
                
                //绑定元素位置到positionX和positionY上面
                this.positionX = top;
                this.positionY = left;
                document.getElementById('move11')
                //移动当前元素
                odiv.style.left = left + 'px';
                odiv.style.top = top + 'px';
            };
            document.onmouseup = (e) => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }    ,
      move(e,index) {
        // let oevent = e ? e : window.event;
        // if (this.sealMove.isDown) {
        //   this.sealPicDivList.top =
        //     oevent.clientY - this.sealMove.starty + this.sealMove.startTop;
        //   this.sealPicDivList.left =
        //     oevent.clientX - this.sealMove.startx + this.sealMove.startLeft;
        // }
        if (this.operationState && !this.opertation.signer) return;
        if (this.scale != 1.0)
          return this.$message.error("请回到适应页面进行拖拽操作");
        this.sealMove.isDown = false
        let odiv
        if(this.opertation.signer){//获取目标元素
          odiv = e.currentTarget.parentElement;  
        }else{
          odiv = e.target   
        }
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft;
            let disY = e.clientY - odiv.offsetTop;
            
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX;    
                let top = e.clientY - disY;
                if(left <= 0 || top <= 0 || left + odiv.clientWidth >= this.canvasSize.width || top + odiv.clientHeight >= this.canvasSize.height) return
                //绑定元素位置到positionX和positionY上面
                this.positionX = top;
                this.positionY = left;
                //移动当前元素
                if(this.opertation.signer){
                  this.signerList[index].top = top / this.actualScale
                  this.signerList[index].left = left / this.actualScale
                }else{
                  this.sealPicDivList.top = top / this.actualScale
                  this.sealPicDivList.left = left / this.actualScale
                  this.sealMove.endTop = top - 24;
                  // this.sealMove.endLeft = left - 10;
                  // this.sealMove.getX = top * this.scaleSize;
                  // this.sealMove.getY = left * this.scaleSize;
                }
                
                // this.sealPicDivList.top = top/this.actualScale
                // this.sealPicDivList.left = left/this.actualScale
                // this.sealMove.endTop = top - 24;
                // this.sealMove.endLeft = left - 10;
                // this.sealMove.getX = top * this.scaleSize;
                // this.sealMove.getY = left * this.scaleSize;
            };
            document.onmouseup = (e) => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
      },
      moveup() {
        this.sealMove.isDown = false;
        this.sealMove.endTop = this.sealPicDivList.top - 24;
        this.sealMove.endLeft = this.sealPicDivList.left - 10;
        this.sealMove.getX = this.sealPicDivList.top * this.scaleSize;
        this.sealMove.getY = this.sealPicDivList.left * this.scaleSize;
        if (this.opertation.signer) {
          this.signState = false;
        }
      },
      openChange() {
        let _list = "";
        let _list1 = "";
        if (this.opertation.signer) {
          _list =
            "这份文件已经在第" + this.sealState + "页进行过意见签署，是否重签？";
          _list1 = "意见";
        } else {
          _list =
            "这份文件已经在第" + this.sealState + "页进行过盖章，是否重新盖章？";
          _list1 = "盖章";
        }
        this.$confirm(_list, {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            this.operationState = false;
            this.$store.state.sealData.sealList = [];
            this.imgState = false;
            this.signState = true;
            this.signState1 = true;
            this.sealState = "";
            Object.assign(this.$data.sealMove, this.$options.data().sealMove);
            this.$message({
              type: "success",
              message: "已删除之前" + _list1
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "保留之前" + _list1
            });
          });
      },
      // 删除签署意见
      deleteSigner(index,type){
        if(type == 1){
          this.signerReturnList.splice(index,1)
        }else{
          this.signerList.splice(index,1)
        }
      },
      bulkPrintFun(){
        let printDiv = document.getElementById("prantPdf")
        for(let item of this.printCheckList){
          let imgNew = document.createElement('div')
          // imgNew.src = item
          imgNew.className = 'printClass'
          imgNew.style = 'width:100%;height:850px'
          imgNew.innerHTML = '<img style="width:100%" src="' + item + '"/>'
          printDiv.appendChild(imgNew)
        }
        let iframe = document.createElement("IFRAME")
        iframe.setAttribute(
          "style",
          "position:fixed;width:0px;height:0px;left:-500px;top:-500px;"
        );
        document.body.appendChild(iframe);
        var doc = null;
        doc = iframe.contentWindow.document;
        doc.body.innerHTML = document.getElementById("prantPdf").innerHTML
        setTimeout(() => {
          doc.close();
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          loadingInstance.close();
        }, 300);
      },
      //打印机
      print() {
        document.getElementById('prantId').innerHTML = ''
        document.getElementById('prantPdf').innerHTML = ''
        if(this.printCheckList.length > 0)
          return this.bulkPrintFun()
        this._loading();
        this.renderPage1("", this.pageNum, "prantId" + 1, 1);
        let _pomise2 = new Promise((res,rej) => {
          setTimeout(val => {
            let id_str, dataURL;
            var iframe = document.createElement("IFRAME");
            iframe.setAttribute(
              "style",
              "position:fixed;width:0px;height:0px;left:-500px;top:-500px;"
            );
            document.body.appendChild(iframe);
            var doc = null;
            doc = iframe.contentWindow.document;
            if (this.suffix == "img") {
              doc.write('<img style="width:100%" src="' + this.imgSrc + '"/>');

              setTimeout(() => {
                doc.close();

                iframe.contentWindow.focus();
                iframe.contentWindow.print();
                loadingInstance.close();
              }, 300);
            } else {
              let _canvas = document.getElementById("prantId").getElementsByTagName("canvas")
              let prantPdfiv = document.getElementById("prantPdf")
              for(let i = 0; i < _canvas.length; i++){
                dataURL = _canvas[i].toDataURL("image/png");
                var imgNew = document.createElement("img");
                imgNew.className = 'printClass'
                imgNew.src = dataURL
                prantPdfiv.appendChild(imgNew);
              }
              // var canvas = document
              //   .getElementById("prantId")
              //   .getElementsByTagName("canvas")[0];
              // dataURL = canvas.toDataURL("image/png");
              // id_str = "pdfPrint_open";

              // doc.write('<img style="width:100%" src="' + dataURL + '"/>');
              doc.body.innerHTML = document.getElementById("prantPdf").innerHTML
              setTimeout(() => {
                doc.close();
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
                loadingInstance.close();
              }, 300);
            }

            if (navigator.userAgent.indexOf("MSIE") > 0) {
              document.body.removeChild(iframe);
            }
          }, 3000);
        })
        
      },
      // 切换图片
      electImg(item, index) {
        this.imgSrc = item;
        this.imgIndexSrc = index;
        this.constObj.imgListIndex = index;
        this.lookImgList[index].fileName?this.fileName = this.lookImgList[index].fileName:null;
      },
      // 左右切换图片
      buttonElectImg(index) {
        this.rotate = 0
        if (this.imgIndexSrc + index < 0 || this.imgIndexSrc + index > this.lookImgList.length - 1) return
        this.imgIndexSrc = this.imgIndexSrc + index;
        this.imgSrc = this.lookImgList[this.imgIndexSrc].displayUrl;
        this.lookImgList[this.imgIndexSrc].fileName?this.fileName = this.lookImgList[this.imgIndexSrc].fileName:null;
        this.constObj.imgListIndex = this.constObj.imgListIndex + index
        // if(this.constObj.imgListIndex < 7 || this.constObj.imgListIndex > this.constObj.imgListLength - 8){
          
        // }else{
          if(index == 1 && Math.abs(this.constObj.marginLeft) < (this.constObj.imgListLength-14) * 68){
            this.constObj.marginLeft = this.constObj.marginLeft - index * 68
          }else if(index == -1 && Math.abs(this.constObj.marginLeft) > 0){
            this.constObj.marginLeft = this.constObj.marginLeft - index * 68
          }
        // }
      },
      // 多图打印
      bulkPrint(){
        this.bulkPrintState = true
      },
      // 关闭多图打印
      endBulkPrint(){
        this.bulkPrintState = false
        this.printCheckList = []
      }
    },
    filters:{
      substring18(val) {
          if(!val || val.length < 18) return val
          return val.substring(0, 18) + "···"
        },
    }
    // watch:{
    //   pdfId(){
    //     this.init()
    //   }
    // }
  };

</script>

<style scoped>
  #container {
    background-color: rgba(0, 0, 0, 0.75);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    text-align: center;
    z-index: 5000;
  }

  #the-canvas {
    overflow-y: auto;
    /* height: 96%; */
    height: -moz-calc(100% - 56px);
    height: -webkit-calc(100% - 56px);
    height: calc(100% - 56px);
    margin-top: 56px;
  }

  /*********************************菜单栏*************/
  .pdf_titleBar {
    position: absolute;
    left: 0px;
    top: 0px;
    color: red;
    font-size: 16px;
    height: 56px;
    width: 100%;
    background: #0d0d0d;
    z-index: 200;
    color: #fdfdfd;
  }

  .pdf_titleBar .iconfont {
    font-size: 22px;
  }

  /*放大缩小*/
  .zoomInOut {
    color: #fff;
    height: 46px;
    /* float: left; */
    /* display: inline-block; */
    cursor: pointer;
    margin: 5px 20px;
    box-sizing: border-box;
  }

  .floatLeft {
    float: left;
  }

  .floatCenter {
    margin: 0 auto;
    width: 300px;
  }

  .floatRight {
    float: right;
  }

  .display {
    display: inline-block;
  }

  .zoomInOut:hover,
  .zoomInOut:hover p {
    color: #1890ff;
  }

  .zoomInOut p {
    height: 18px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.65);
  }

  .file_name{
    line-height: 56px;
    text-indent: 40px;
  }

  /*页码跳转*/
  .pdf_page_num {
    margin-left: 180px;
    width: 180px;
    height: 40px;
    float: left;
  }

  .pdf_page_num i {
    display: inline-block;
    width: 28px;
    height: 40px;
    font-size: 22px !important;
    line-height: 48px;
    cursor: pointer;
    transition: all 100ms;
    text-align: center;
  }

  .pdf_page_num i:hover {
    box-shadow: inset 0 0 12px 2px #333;
  }

  .page_num {
    width: 100px;
    height: 46px;
    line-height: 40px;
    margin: 5px 0 !important;
    vertical-align: top;
  }

  .page_num:hover {
    color: #fff;
  }

  .page_num .page_inp {
    width: 40px;
    text-align: center;
    height: 25px;
    background-color: #323232;
    border-radius: 2px;
    outline: none;
    border: none;
    color: #fff;
  }

  /*pdf框状态栏*/
  .box_state {
    width: 120px;
    height: 40px;
    float: right;
    color: #666;
  }

  .pdf_box_state {
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 45px;
    float: right;
    cursor: pointer;
    box-sizing: border-box;
    padding-left: 5px;
    transition: all 300ms;
  }

  .pdf_popup:hover {
    box-shadow: inset 0 0 15px 0px #333;
    color: #57b497;
  }

  .pdf_close:hover {
    box-shadow: inset 0 0 15px 0px #333;
    color: #f56c6c;
  }

  /*****************图标栏*/
  .pdf_titleBar .icontubiaozhizuomoban {
    color: #efb336;
  }

  .pdf_titleBar .icondayin {
    color: #1890ff;
  }

  .pdf_titleBar .iconsuoxiao {
    font-size: 18px;
  }

  .pdf_titleBar .iconfangda {
    font-size: 18px;
  }

  .pdfClass {
    position: relative;
    margin: 0 auto;
    padding: 5px 0;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 4px;
    width: 100%;
    height: 100%;
  }

  .pdfClass1 {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 56px;
    bottom: 0;
    transition: all 200ms;
  }

  .sealPicDiv {
    position: absolute;
    left: 0;
    top: 0;
    /* width: 200px;
  height: 200px; */
    box-sizing: border-box;
  }

  .sealPicDiv img {
    height: 100%;
  }

  .cover_class {
    position: absolute;
    left: 0;
    top: 0;
  }

  .cursor_move {
    z-index: 99999;
    cursor: move;
  }

  .signer_class {
    position: absolute;
    top: 20px;
    left: 20px;
    background-color: rgba(255, 255, 255, 0);
  }

  .textarea_class {
    background-color: rgba(255, 255, 255, 0);
    border: 0;
    /* width: 150px;
  height: 100px; */
    min-width: 50px;
    resize: none;
    min-height: 30px;
    outline: none;
    /* padding: 5px; */
    overflow: hidden;
    font-size: 12px;
    box-sizing: border-box;
    /* border: #fff 1px dashed; */
  }

  .textarea_class:focus {
    resize: both;
    border: #1890ff 1px dashed;
  }

  .signer_class_drag {
    text-align: left;
    width: 100%;
    height: 24px;
    cursor: move;
    color: #1890ff;
    overflow: hidden;
    position: relative;
  }

  .signer_class_drag i {
    font-size: 24px;
  }

  .signer_class_drag span:last-child{
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .button {
    width: 65px;
    height: 32px;
    line-height: 0;
    margin: 12px 26px 0px 0;
  }

  .color {
    color: rgba(255, 255, 255, 0.65);
  }

  .img_list {
    width: 100%;
    height: 100%;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .suffix_img {
    position: absolute;
    /* width: 100%; */
    height: -moz-calc(100% - 72px);
    height: -webkit-calc(100% - 72px);
    height: calc(100% - 72px);
    /* top: 45.5%; */
    top: calc(50% - 36px);
    left: 50%;
    /* transform: translateX(-50%)translateY(-50%); */
    background: #fff;
  }

  .suffix_img img {
    /* width: 100%; */
    height: 100%;
  }

  .img_list_footer {
    position: absolute;
    width: 100%;
    height: 68px;
    bottom: 0;
    /* background-color: red; */
    background-color: #0d0d0d;
  }

  .img_list_footer_ul {
    height: 100%;
    max-width: 952px;
    display: inline-block;
    overflow: hidden;
  }
  .img_list_footer ul {
    height: 100%;
    display: inline-block;
  }

  .img_list_footer ul li {
    vertical-align: middle;
    display: inline-block;
    margin: 0 auto;
    cursor: pointer;
    box-sizing: border-box;
    width: 68px;
    height: 68px;
    padding: 2px;
    overflow: hidden;
    border: 2px solid #0d0d0d;
    background-color: #313131;
    opacity: 0.5;
    position: relative;
  }

  .img_list_footer_border {
    border: 2px solid #1890ff !important;
    opacity: 1!important;
  }

  .img_list_footer_div {
    display: inline-block;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    line-height: 50px;
    background-color: #313131;
    cursor: pointer;
    vertical-align: middle;
    margin-top: -56px;
  }

  .img_list_footer_div i {
    vertical-align: middle;
    font-size: 24px !important;
    color: #fff;
  }

  .img_list_footer ul li img {
    /* -webkit-transform:scale(.2,.2);
    -moz-transform:scale(.2,.2);
    -o-transform:scale(.2,.2); */
    /* max-width: 100%; */
    width: 160px;
    /* height: 60px; */
  }
  .signer_return_class_drag {
    width: 24px;
    height: 24px;
    color: #fff;
    background: #1890ff;
    overflow: hidden;
    position: absolute;
     top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    display: none;
  }

  .signer_return_class_drag i {
    font-size: 24px;
  }

  .signer_return_class {
    position: absolute;
    top: 20px;
    left: 20px;
  }
  .signer_return_class:hover .signer_return_class_drag{
    display: block;
  }
  .loadingClass{
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.75);
  }
  .loadingClassCentre{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .icon_size{
    font-size: 22px;
  }
  
</style>
<style>
  #showPDF canvas {
    width: 100%;
    height: 100%;
  }
.printClass{
    page-break-after:always;
  }
  @page{
    margin-bottom: 0mm;
    margin-top: 0mm;
  }
  .el-loading-mask{
    z-index: 9999!important;
  }
  .img_list_footer_ul .el-checkbox{
    position: absolute;
    top: 0;
    right: -8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/paging/pcClient/popupModule/structFile/seal/electronicSeal.vue